import { useEffect, useState } from 'react'

import { Box, Button, Input, Modal, Text } from '@fairfashion/design-system'

import { ICompany } from '../../../../sdk/company/company.types'
import { sdk } from '../../../../services/sdk'
import {
  checkTaxidType,
  docMask,
} from '../../../../utilities/masks/brasilianDocuments'

import { AddProviderProps } from './add-provider.types'
import { AddProviderForm } from './AddProviderForm/add-provider-form.comp'

export const AddProvider = ({
  open,
  setOpen,
  loading,
  onSubmit,
}: AddProviderProps) => {
  const [cnpjCpf, setCnpjCpf] = useState<string>('')
  const [alreadyExists, setAlreadyExists] = useState<boolean>(false)
  const [companyData, setCompanyData] = useState<ICompany | null>(null)
  const [showSearch, setShowSearch] = useState(true)

  const getCompany = async () => {
    if (cnpjCpf.trim().length === 0) {
      return
    }
    const taxId = cnpjCpf.replace(/\D+/g, '')
    const type = checkTaxidType(cnpjCpf)
    try {
      const _response = await sdk.company.getCompany(taxId)
      if (_response) {
        setAlreadyExists(true)
        setCompanyData(_response)
        setShowSearch(false)
      }
    } catch (error) {
      if (type === 'cnpj') {
        getCompanyReceita()
      } else {
        setCompanyData(null)
        setShowSearch(false)
      }
      setAlreadyExists(false)
    }
  }

  const getCompanyReceita = async () => {
    const taxId = cnpjCpf.replace(/\D+/g, '')

    try {
      const _response = await sdk.providers.cnpjConsult(taxId)
      setCompanyData(_response)
    } catch (error) {
      setCompanyData(null)
    }
  }

  useEffect(() => {
    companyData && setShowSearch(false)
  }, [companyData])

  useEffect(() => {
    if (!open) {
      setCompanyData(null), setAlreadyExists(false), setShowSearch(true)
    }
  }, [open])

  useEffect(() => {
    !showSearch && setCnpjCpf('')
  }, [showSearch])

  return (
    <Modal
      open={open}
      onClose={setOpen}
      maxWidth="90%"
      width="830px"
      customTitle={
        <Text textTransform="uppercase" size="small" color="grey_3">
          Adicionar um fornecedor
        </Text>
      }
    >
      <Box width="100%" direction="column" paddingX={1}>
        {showSearch && (
          <Box width="100%" gap={2} direction="column" alignItems="flex-end">
            <Input
              label="Busca por um CNPJ"
              placeholder="CNPJ"
              onChange={(e) => setCnpjCpf(docMask(e.target.value))}
              mask="00.000.000/0000-00"
            />
            <Button onClick={getCompany} disabled={!cnpjCpf}>
              Buscar
            </Button>
          </Box>
        )}

        {!showSearch && open && (
          <AddProviderForm
            alreadyExists={alreadyExists}
            data={companyData}
            setOpen={setOpen}
            setShowSearch={setShowSearch}
            onSubmit={onSubmit}
            loading={loading}
          />
        )}
      </Box>
    </Modal>
  )
}
